import ContactTemplate from '~templates/contact'
export default ContactTemplate